<!--
 * @Author: Shber
 * @Date: 2023-02-17 14:40:58
 * @LastEditors: Shber
 * @LastEditTime: 2023-02-28 17:31:46
 * @Description:
-->
<template>
  <div>
    <span v-wechat-title="dataInfo.goods_title" />
    <GCLOADING :is-show="isLoading" />
    <GCHEADER v-if="!tipShow" des="goodsview" :param="pathId" :webapp-link="webappLink" />
    <GCGUIDE :down-show="guideShow" />
    <ShareInfo :share-info="shareData" />

    <div class="goods_swiper">
      <template v-if="!isLoading">
        <Swipe :autoplay="3000" class="swiper" :show-indicators="dataInfo.goods_pic.length" indicator-color="#333">
          <SwipeItem v-for="(img, i) in dataInfo.goods_pic" :key="i">
            <VanImage :src="img" fit="cover" alt="商品图" class="goods_img" />
          </SwipeItem>
        </Swipe>
      </template>

    </div>
    <div :class="{'goods_content':true, 'goods_content_full': isFull}">
      <div class="title_tag">
        <h2 class="goods_title fw_bold">{{ dataInfo.goods_title }}</h2>
        <ul class="tag_list mt10">
          <li v-for="tag in dataInfo.tags" :key="tag.id" class="list_item">{{ tag.title }}</li>
        </ul>
      </div>
      <div v-if="dataInfo.back_food.length>0" class="feedback">
        <h2 class="title fw_bold" title="试用反馈">{{ $t('goods.title1') }} <span v-show="dataInfo.back_food.length>3" title="全部" @click="goAll()">{{ $t('goods.text') }}</span></h2>
        <div class="list">
          <div class="list_content">
            <div v-for="item in dataInfo.back_food" :key="item.id" class="list_items" @click="goPath(item.des, item.id)">
              <VanImage :src="item.firstpic" fit="cover" position="center" class="img" />
              <p class="list_des text_overflow2 fw_bold">{{ item.food_name }}</p>
            </div>
          </div>
        </div>
      </div>

      <template v-if="dataInfo.content">
        <div class="gray_lines" />
        <Markdown :content="dataInfo.content" />
      </template>

      <template v-if="dataInfo.parameters.length">
        <div class="gray_lines" />
        <div class="goods_param pd_lr16">
          <h2 class="title fw_bold" title="产品参数">{{ $t('goods.title') }}</h2>
          <ul class="param_list">
            <li v-for="(item, p) in dataInfo.parameters" :key="p">
              <span class="label mr_10">{{ item.label }}</span>
              <div class="content_txt">
                <p v-for="(text,t) in item.value" :key="t"> <i v-if="item.value.length>1">{{ t+1 }}.</i> {{ text }}</p>
              </div>
            </li>
          </ul>
        </div>
      </template>
    </div>
    <div :class="{'fixed_bar':true, 'is_full': isFull}">
      <div>
        <div class="user_box" @click="goPath('userview', dataInfo.vendor_info.uid)">
          <img :src="dataInfo.vendor_info.usr_pic" alt="user_pic" class="user_pic">
          <img v-if="dataInfo.vendor_info.auth_pic" :src="dataInfo.vendor_info.auth_pic" alt="auth_icon" class="auth_icon">
        </div>
        <span class="fw_bold text_over nick_name">{{ dataInfo.vendor_info.nick_name }}</span>
      </div>
      <span v-if="dataInfo.trial_id" class="button fw_bold" title="申请试用" @click="goH5('trialview', dataInfo.trial_id)">{{ $t('goods.btn1') }}</span>
      <template v-else>
        <span v-if="dataInfo.is_apply_open_trial" class="button button2 fw_bold" title="我想要" @click="setDialogShow()">{{ $t('goods.btn2') }} <i class="icon_tip" /></span>
        <span v-else class="button button1 fw_bold" title="我想要" @click="goPath('goodsview', pathId)">{{ $t('goods.btn2') }}</span>
      </template>
    </div>

    <van-dialog :show="dialogShow" class="mc_dialog" width="280px" :show-confirm-button="false">
      <div>
        <p class="dialog_txt">{{ $t('goods.tip') }}</p>
        <span class="dialog_button fw_bold" @click="dialogShow = false">{{ $t('auth.nameAuth.isKnow') }}</span>
      </div>
    </van-dialog>
  </div>
</template>
<script setup>
import '@/style/scss/goodsview/index.scss'
import config from '@/config/config'
import { isGteatChefbrowser, platformType, fullScreen, isWechat, isAndroid } from '@/utils'
import { ref, reactive, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { Swipe, SwipeItem, Image as VanImage, Dialog, Toast } from 'vant'
import { get, post } from '@/api/ajax'
import { superLink } from '@/utils'
import ShareInfo from '@/components/shareInfo'
import GCHEADER from '@/components/gc-header'
import GCGUIDE from '@/components/gc-guide'

import GCLOADING from '@/components/gc-loading'
import Markdown from '@/components/Markdown.vue'
const VanDialog = Dialog.Component // 弹框

const router = useRouter()
const dialogShow = ref(false)
const isLoading = ref(true)
const guideShow = ref(false) // 默认浏览器打开引导框
const tipShow = ref(isGteatChefbrowser()) // 是否展示打开app的tabbar
const isFull = ref(fullScreen())
const pathId = ref(router.currentRoute.value.query.id) // 页面id
const webappLink = ref(`${config.webapplink}/goodsview?id=${pathId.value}`) // 打开的H5链接
let dataInfo = reactive({
  goods_title: '',
  goods_pic: [],
  back_food: [],
  vendor_info: {},
  parameters: []
})
const shareData = reactive({ // 分享数据
  share_title: '',
  share_des: '',
  share_link: '',
  share_img: ''
})

onMounted(() => {
  sensors.track('GoodsView', {
    PlatformType: platformType(),
    goods_id: pathId.value,
    goods_title: dataInfo.goods_title,
    nickname: dataInfo.vendor_info.nick_name,
    uid: dataInfo.vendor_info.uid
  })
})

const getDataInfo = async() => { // 获取详情数据
  const res = await get('/api/goods/detail', { id: pathId.value })
  if (res.code === 1) {
    dataInfo = { ...res.data }
    dataInfo.goods_pic = res.data.goods_pic
    shareData.share_title = dataInfo.share.share_title
    shareData.share_desc = dataInfo.share.share_desc
    shareData.share_link = dataInfo.share.share_link
    shareData.share_img = dataInfo.share.share_img
    isLoading.value = false
  } else {
    Toast(res.message)
  }
}
getDataInfo()

// const onAplay = () => { // 申请试用
//   post('/api/goods/apply_open_trial', { goods_id: pathId.value }).then(res => {
//     if (res.code === 1) {
//       dialogShow.value = true
//     } else {
//       Toast(res.message)
//     }
//     sensors.track('GoodsViewButtonClick', {
//       PlatformType: platformType(),
//       goods_id: pathId.value,
//       goods_title: dataInfo.goods_title,
//       nickname: dataInfo.vendor_info.nick_name,
//       uid: dataInfo.vendor_info.nick_name.uid,
//       button_type: '我想要'
//     })
//   })
// }
const setDialogShow = () => {
  dialogShow.value = true
}

const goH5 = (_des, _skuid) => {
  sensors.track('GoodsViewButtonClick', {
    PlatformType: platformType(),
    goods_id: pathId.value,
    goods_title: dataInfo.goods_title,
    nickname: dataInfo.vendor_info.nick_name,
    uid: dataInfo.vendor_info.nick_name.uid,
    button_type: '申请试用'
  })
  location = `${config.webapplink}/${_des}?id=${_skuid}`
}
const goAll = () => {
  sensors.track('GoodsViewButtonClick', {
    PlatformType: platformType(),
    goods_id: pathId.value,
    goods_title: dataInfo.goods_title,
    nickname: dataInfo.vendor_info.nick_name,
    uid: dataInfo.vendor_info.nick_name.uid,
    button_type: '更多作品'
  })
  location = `${config.webapplink}/triallist?id=${pathId.value}`
}

const goPath = (_des, _skuid) => {
  if (isAndroid() && isWechat()) {
    guideShow.value = true
    return false
  }
  const data = `{
        "des": "${_des}", 
        "skuid": "${_skuid}",
        "link": "${config.webapplink}/${_des}?id=${_skuid}"
      }`
  return superLink(data)
}
</script>
